// extracted by mini-css-extract-plugin
export default {"App":"App_App__UtNo-","App-logo":"App_App-logo__JO+zH","App-logo-spin":"App_App-logo-spin__qPZ2a","App-header":"App_App-header__hBqZ4","App-link":"App_App-link__UGRR7"};